import React from 'react';
import IconName from "../../../svgLogo/SvgLogo";

const GalleryImageResponsive = () => {
    return (
        <div
            className="gallery-image-responsive position-relative xmb-6 d-flex justify-content-center align-items-center">
            <div className="price-box-responsive position-absolute">
                <div className="title-timer-product d-flex">
                    <div className="text-offer"><span className="txt">پیشنهاد ویژه</span></div>
                    <div className="number-timer">
                        <span className="timer-interval-box"
                              data-time-offer="november 20, 2021 19:37:25">00:00:00</span>
                    </div>
                </div>
            </div>
            <div className="img-gallery-responsive">
                <img src="./assets/sample-image/gallery-img.png" alt="ed"/>
            </div>
            <div className="gallery-swiper-wrapper xp-4 position-absolute">
                <div className="link-products-gallery-prev-responsive position-absolute">
                    <IconName name="chevron_left" className="icon"/>
                </div>
                <div className="swiper gallery-swiper-image-responsive">
                    <div className="swiper-wrapper">
                        <div className="swiper-slide">
                            <div className="img-box-responsive" id="item1"
                                 data-modal-image="https://saymandigital.com/storage/uploads/2021/10/26/HS5ficL79EKHr8tpQezFeg5POjxinQwLLA95M3Li_medium.webp">
                                <img src="./assets/sample-image/image 29.png" alt="img1"/>
                            </div>
                        </div>
                        <div className="swiper-slide">
                            <div className="img-box-responsive" id="item2"
                                 data-modal-image="https://saymandigital.com/storage/uploads/2021/10/26/z4OXdeqDYzq6P2ypp6HisuSN2qrIJ1GLeZhY6hKq_medium.webp">
                                <img src="./assets/sample-image/image 30.png" alt="img1"/>
                            </div>
                        </div>
                        <div className="swiper-slide">
                            <div className="img-box-responsive"
                                 data-modal-image="https://saymandigital.com/storage/uploads/2021/10/26/x1IVuf3xK26rbAt0XXic5AaDO36T1SMPfvvIMRTL_medium.webp">
                                <img src="./assets/sample-image/image 31.png" alt="img1"/>
                            </div>
                        </div>
                        <div className="swiper-slide">
                            <div className="img-box-responsive video-play-responsive"
                                 data-modal-image="https://www.aparat.com/video/video/embed/videohash/PRWm6/vt/frame">
                                <img src="./assets/sample-image/f6ca859b10af45a6074568ec043ddb20.png" alt="img1"/>
                                <IconName name="play" className="icon position-absolute"/>
                            </div>
                        </div>
                        <div className="swiper-slide">
                            <div className="img-box-responsive"
                                 data-modal-image="https://saymandigital.com/storage/uploads/2021/10/27/WbfVYhaM6JUtvLlQIG3LcPgnNBAdkoR3YGUpHrQk_medium.webp">
                                <img src="./assets/sample-image/image 31.png" alt="img1"/>
                            </div>
                        </div>
                        <div className="swiper-slide">
                            <div className="img-box-responsive"
                                 data-modal-image="https://saymandigital.com/storage/uploads/2021/10/27/PQpolGyoLncxLRDV4PeklAQi2ns61XnI4u7AwgAr_medium.webp">
                                <img src="./assets/sample-image/image 31.png" alt="img1"/>
                            </div>
                        </div>
                        <div className="swiper-slide">
                            <div className="img-box-responsive"
                                 data-modal-image="https://saymandigital.com/storage/uploads/2021/10/27/ImliiEB9q1ZYWOiaI9nZP62B3Os3F7bHxPq2nzjr_medium.webp">
                                <img src="./assets/sample-image/image 31.png" alt="img1"/>
                            </div>
                        </div>
                        <div className="swiper-slide">
                            <div className="img-box-responsive"
                                 data-modal-image="https://saymandigital.com/storage/uploads/2021/10/27/cZvs5uWfTgZUJwnLLKL650gBuzYfv4oec9ViXRAs_medium.webp">
                                <img src="./assets/sample-image/image 29.png" alt="img1"/>
                            </div>
                        </div>
                        <div className="swiper-slide">
                            <div className="img-box-responsive"
                                 data-modal-image="https://saymandigital.com/storage/uploads/2021/10/27/fFEg5Ic1VNzNjl55f7nky2pifGgpEQyxpX06PGqv_medium.webp">
                                <img src="./assets/sample-image/image 30.png" alt="img1"/>
                            </div>
                        </div>
                        <div className="swiper-slide">
                            <div className="img-box-responsive"
                                 data-modal-image="https://saymandigital.com/storage/uploads/2021/10/27/xyl0HSWekQaUDExNWZi9KeVOIiSRsTejR8xf7Q3U_medium.webp">
                                <img src="./assets/sample-image/image 31.png" alt="img1"/>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="link-products-gallery-next-responsive position-absolute">
                    <IconName name="chevron_left" className="icon"/>
                </div>
            </div>
        </div>
    );
};

export default GalleryImageResponsive;
